import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {};

const enhance = compose();

const button = enhance(({ className, onClickAction }) => {
  return (
    <Button color="primary" onClick={onClickAction} className={className}>
      閉じる
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
